import gql from 'graphql-tag'

import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'

const URL = process.env.REACT_APP_GRAPH_API_URL
const PUBLIC_URL = process.env.REACT_APP_GRAPH_API_PUBLIC_URL

const client = new ApolloClient({
  link: createHttpLink({
    uri: URL,
    credentials: 'include'
  }),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    }
  }
})

const publicClient = new ApolloClient({
  link: createHttpLink({
    uri: PUBLIC_URL,
    credentials: 'include'
  }),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    }
  }
})

export default {
  query: (query, variables = {}) =>
    client.query({
      query: gql(query),
      variables
    }),
  publicQuery: (query, variables = {}) =>
    publicClient.query({
      query: gql(query),
      variables
    }),
  publicMutation: (mutation, variables = {}) =>
    publicClient.mutate({
      mutation: gql(mutation),
      variables
    }),
  mutation: (mutation, variables = {}) =>
    client.mutate({
      mutation: gql(mutation),
      variables
    })
}



// WEBPACK FOOTER //
// ./src/api/gqlClient.js